<h1 translate>m2.ergebnis.robustheitsmass</h1>
<h4 class="pdt-20" translate>m2.cockpit.card.verteilung-leave-one-out</h4>
<div  class="cockpit-view">
  <h5 translate>m2.sprint3.cockpit.card.funktionswert.diagramm</h5>
  <div id="svgContainerChartLeaveOneOut"  ></div>
</div>
